import Vue from 'vue'
import { mapState } from 'vuex'

import Loading from '@/components/loading/loading.vue'
import ImageLink from '@/components/image-link/image-link.vue'
import Announcement from './components/announcement/announcement.vue'
import Content from './components/content/content.vue'
import Plan from './components/plan/plan.vue'
import AnnouncementModal from './components/announcement/modal.vue'
import BookmarkEditActivator from './components/bookmark-edit/activator.vue'
import BookmarkEditModal from './components/bookmark-edit/modal.vue'
import VButton from '@/components/button/basic-button.vue'
import ContractPlan from './components/corp-plan/plan.vue'

import { getAnnouncements } from '@/api/announcement'
import { getContents, updateContentBookmarks } from '@/api/content'
import { corpMixins } from '@/mixins/corp-mixins'

interface Data {
  loadingContents: boolean
  showAnnouncementModal: boolean
  showBookmarkModal: boolean
  selectedAnnouncement: model.Announcement | undefined
  announcements: model.Announcement[]
  bookmarkContents: model.Content[]
  contents: model.Content[]
  activePlans: any
}

export default Vue.extend({
  mixins: [corpMixins],
  name: 'Dashboard',
  components: {
    Loading,
    ImageLink,
    Announcement,
    'v-content': Content,
    AnnouncementModal,
    BookmarkEditModal,
    BookmarkEditActivator,
    Plan,
    VButton,
    ContractPlan
  },
  data(): Data {
    return {
      loadingContents: false,
      showAnnouncementModal: false,
      showBookmarkModal: false,
      selectedAnnouncement: undefined,
      announcements: [],
      bookmarkContents: [],
      contents: [],
      activePlans: [],
    }
  },

  created() {
    this.fetchData()
  },

  computed: {
    ...mapState(['loading', 'user']),
    checkExpirationDate(): boolean {
      const plantsDate = new Date(this.user.corp_contract.current_period_end)
      const currentDate: any = Date.now()
      return plantsDate > currentDate
    }
  },

  methods: {
    fetchData(this: any) {
      this.$store.dispatch('loading')
      Promise.all([getAnnouncements(), getContents(true)])
        .then(([aRes, cRes]) => {
          this.$store.dispatch('loading', false)
          if (this.isCorpRole) {
            let withAnnAssign: any[]
            let withoutAnnAssign: any[]
            withAnnAssign = aRes.data.filter((res: any) => {
              return res.corp_id === this.user.corp_id
            })
            withoutAnnAssign = aRes.data.filter((res: any) => {
              return res.corp_id === null
            })
            this.announcements.push(...withAnnAssign, ...withoutAnnAssign)
            this.announcements.sort((a: any, b: any) => {
              return (b.started_at - a.started_at)
            })
          } else {
            this.announcements = aRes.data.filter((res: any) => {
              return res.corp_id === null
            })
          }
          this.bookmarkContents = cRes.data
          this.activePlans = this.user.contracts.filter(
            (c: { is_active: boolean }) => c.is_active
          )
        })
        .catch(() => {
          this.$store.dispatch('loading', false)
        })
    },

    handleClickAnnouncement(announcement: model.Announcement) {
      this.$store.dispatch('clearMessage')
      this.selectedAnnouncement = announcement
      this.showAnnouncementModal = true
    },

    updateBookmark(contents: model.Content[]) {
      this.$store.dispatch('loading')
      updateContentBookmarks(contents.map(c => c.id))
        .then(res => {
          this.showBookmarkModal = false
          getContents(true).then(res => {
            this.bookmarkContents = res.data
            this.$store.dispatch('showMessage', 'MYコンテンツを更新しました')
            this.$store.dispatch('loading', false)
          })
        })
        .catch(() => {
          this.showBookmarkModal = false
          this.$store.dispatch(
            'showErrorMessage',
            'MYコンテンツの更新に失敗しました'
          )
        })
    },

    handleClickContent(content: any) {
      this.$router.push({ path: `/contents/${content.id}` })
    },

    handleToContentList() {
      this.$router.push({ path: `/contents` })
    },
  }
})
